import {
    KeyPairingStateResponse,
    OemAuthResponse,
    OemMetadataResponse,
    PairingUrlResponse,
    VehicleConfigStateResponse,
} from '../../app/features/connect/domain/oem.model';
import { KeyPairingState } from '../../app/features/connect/infrastructure/enums/key-pairing-state.enum';

export const OEM_AUTH_RESPONSE_MOCK: OemAuthResponse = {
    oem_auth_uri: 'https://the.oem.com/oauth/token',
};

export const OEM_METADATA_RESPONSE_MOCK: OemMetadataResponse = {
    additionalProp1: {},
};

export const OEM_KEY_PAIRING_STATE_RESPONSE_MOCK: KeyPairingStateResponse = {
    key_pairing_state: KeyPairingState.PAIRED,
};

export const OEM_PAIRING_URL_RESPONSE_MOCK: PairingUrlResponse = {
    tesla_pairing_url: 'https://www.tesla.com/_ak/tft.ferrovialdigitalhub.com/',
};

export const OEM_VEHICLE_CONFIG_STATE_RESPONSE_MOCK: VehicleConfigStateResponse = {
    synced: true,
    limit_reached: true,
    key_paired: true,
};
